import { useEffect, useMemo, useState } from 'react'
import { FALLBACK_SLIDES } from '../../constants'
import type { Slide } from '../../types'

export const useHomeSlideState = () => {
  const [slides, setSlides] = useState<Slide[]>(FALLBACK_SLIDES)
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (currentIndex > slides.length - 1) {
      setCurrentIndex(Math.max(slides.length - 1, 0))
    }
  }, [slides.length, currentIndex])

  const currentSlide = useMemo(() => slides[currentIndex] ?? slides[0], [currentIndex, slides])

  const goNext = () => {
    if (!slides.length) return
    setCurrentIndex((prev) => (prev + 1) % slides.length)
  }

  const goPrev = () => {
    if (!slides.length) return
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length)
  }

  return {
    slides,
    setSlides,
    currentSlide,
    currentIndex,
    setCurrentIndex,
    goNext,
    goPrev,
  }
}
